
export default {
    apiKey: "AIzaSyBYjhUNr0fv0M2FRn7EWoOSQlk2q-wM_YU",
    authDomain: "group-arrangement.firebaseapp.com",
    projectId: "group-arrangement",
    storageBucket: "group-arrangement.appspot.com",
    messagingSenderId: "754680775825",
    appId: "1:754680775825:web:a92a2650b3e2f0e5ecab30",
    measurementId: "G-CS46DFFN0N"
};